// extracted by mini-css-extract-plugin
export default {"header":"MainHeader_header__7bOui","button":"MainHeader_button__3q2yC"};